import type { Coerced, DateRangeValue } from '@repo/types/Types';
import { coerce } from './coerceForTable';

function isDateRangeValue(value: unknown): value is DateRangeValue {
  if (typeof value !== 'object') return false;
  if (value === null) return false;
  if (!('range' in value)) return false;
  if (typeof value.range !== 'object') return false;
  if (value.range === null) return false;
  if ('start' in value.range && 'end' in value.range) return true;
  return false;
}

export function coerceValue<T>(value: T): { value: Coerced<T> } | DateRangeValue {
  if (isDateRangeValue(value)) {
    return value;
  }
  return { value: coerce(value) };
}

type Operator = 'NEQ' | 'FUZZ' | 'EQ' | undefined;

export class Value<T> {
  constructor(
    public value: T,
    public op: Operator = undefined
  ) {}
}

export class Fuzz<T> extends Value<T> {
  constructor(public value: T) {
    super(value, 'FUZZ');
  }
}

export class Not<T> extends Value<T> {
  constructor(public value: T) {
    super(value, 'NEQ');
  }
}

export class Equals<T> extends Value<T> {
  constructor(public value: T) {
    super(value, 'EQ');
  }
}

export const NOT_NULL = new Not(null);

export const coerceQueryInput = <T>(data: T, key: string) => {
  if (data instanceof Value) {
    return {
      key,
      value: coerceValue(data.value),
      op: data.op,
    };
  }

  return {
    key,
    value: coerceValue(data),
    op: undefined,
  };
};
